import './ChangesApp.css';
import HeroSection from './screens/FirstScreen';
import SecondScreen from './screens/SecondScreen';
import RecommendationsSection from './screens/ThirdScreenRecommendations';
import AboutMe from './components/Me';
import WhatHappens from './screens/ThirdScreen';
import ContentShowcase from './screens/ContentShowcase';
import ServicesShowcase from './components/Services';
import ForthScreen from './screens/ForthScreen';
import ByMe from '../components/ByMe/ByMe';
import StatsShowcase from './components/Count';

function ChangesApp() {
  return <>
    <HeroSection/>
    <SecondScreen/>
    <RecommendationsSection/>
    <StatsShowcase/>
    <AboutMe/>
    <WhatHappens/>
    <ContentShowcase/>
    <ServicesShowcase/>
    <ForthScreen/>
    <ByMe/>
  </>
}

export default ChangesApp;
